<div class="comp-grid-cell-image">
    <div *ngIf="isImageAvailable">
        <img [src]="src" (click)="open(content)" class="comp-grid-cell-image__main-img"/>
    </div>
    <div *ngIf="!isImageAvailable">
        <img [src]="noImage"/>
        <p style="text-align: center">No file available</p>
    </div>
</div>

<ng-template #content let-modal>
    <div *ngIf="isImageAvailable">
        <img [src]="src" class="comp-grid-cell-image__modal-img" />
    </div>
</ng-template>